import { UnauthorizedError, i18nError } from "@/@types/api-error";
import { bookmarksAtom } from "@/atoms/bookmark";
import { BookmarkUsecase } from "@/usecases/bookmark/BookmarkUsecase";
import { usePrivatePageContext } from "@/utils/hooks/private-page.hooks";
import { DataSchema } from "common";
import { useAtom } from "jotai";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

export const useBookmarkView = () => {
  const { t } = useTranslation();
  const { apiClient, logout } = usePrivatePageContext();
  const [bookmarks, setBookmarks] = useAtom(bookmarksAtom);
  const [apiErrorMessage, setApiErrorMessage] = useState<string>("");
  const [apiErrorDialogOpen, setApiErrorDialogOpen] = useState<boolean>(false);

  const [open, setOpen] = useState<boolean>(false);
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState<boolean>(false);
  const [deleteBookmark, setDeleteBookmark] = useState<DataSchema.Bookmark>();

  const callDeleteBookmark = useCallback(() => {
    if (!deleteBookmark) {
      return;
    }
    BookmarkUsecase.deleteBookmark(apiClient, deleteBookmark.documentId, deleteBookmark.pageNo)
      .then(() => {
        const deletedHistories = bookmarks.filter((bookmark) => {
          return !(bookmark.documentId === deleteBookmark.documentId && bookmark.pageNo === deleteBookmark.pageNo);
        });
        setBookmarks(deletedHistories);
        setDeleteBookmark(undefined);
      })
      .catch((error) => {
        if (error instanceof UnauthorizedError) {
          logout();
          return;
        }

        if (error instanceof i18nError) {
          setApiErrorMessage(t(error.i18nKey));
        } else {
          setApiErrorMessage(t("api_error_network"));
        }
        setApiErrorDialogOpen(true);
      });
  }, [apiClient, bookmarks, deleteBookmark, logout, setBookmarks, t]);

  const onClickTrash = useCallback((data: DataSchema.Bookmark) => {
    setDeleteBookmark(data);
    setDeleteConfirmOpen(true);
  }, []);

  return {
    t,
    apiErrorMessage,
    apiErrorDialogOpen,
    setApiErrorDialogOpen,
    bookmarks,
    open,
    setOpen,
    onClickTrash,
    deleteBookmark,
    deleteConfirmOpen,
    setDeleteConfirmOpen,
    callDeleteBookmark,
  };
};
